import React from "react";

import ArticleImmersiveAd from "~components/StoryImmersiveAd";

import styles from "./styles.module.css";

export default function BottomArticleAd() {
    return <ArticleImmersiveAd className={styles.bottomArticleAd} />;
}
